module.exports = __webpack_public_path__ + "static/img/logo-car.11e770d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-car.png
// module id = BGOu
// module chunks = 3